import React, { Component } from "react";
import { observer } from "mobx-react";
import { MdLineWeight } from "react-icons/md";
import COLORS from "scss/colors.module.scss";
import { Dropdown } from "react-bootstrap";
import { DIMENSIONS } from "utils/Dimensions";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import styled from "styled-components";

class RowHeight extends Component {
  constructor(props) {
    super(props);
    this.state = {
      availableHeights: [
        { label: "Compact", height: DIMENSIONS.cell_height_compact },
        { label: "Short", height: DIMENSIONS.cell_height_short },
        { label: "Medium", height: DIMENSIONS.cell_height_medium },
        { label: "Tall", height: DIMENSIONS.cell_height_tall },
        { label: "Extra Tall", height: DIMENSIONS.cell_height_extra_tall },
      ],
      anchorEl: null,
    };
  }

  handleClick = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  render() {
    return (
      <>
        <StyledRowHeightDiv className="d-flex" onClick={this.handleClick}>
          <MdLineWeight
            size={18}
            color={COLORS.TEXT_COLOR}
            data-tip="Row height"
            data-for="rowHeightTooltip"
          />
          <StyledHeightTitle>Height</StyledHeightTitle>
        </StyledRowHeightDiv>
        <Menu
          id="simple-menu"
          anchorEl={this.state.anchorEl}
          keepMounted
          open={Boolean(this.state.anchorEl)}
          onClose={this.handleClose}
          getContentAnchorEl={null}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
        >
          {this.state.availableHeights.map((item, index) => (
            <MenuItem
              key={index}
              className={"rowHeight"}
              onClick={() => {
                this.props.setRowHeight(item.height);
                this.handleClose();
              }}
              selected={this.props.rowHeight === item.height}
            >
              {item.label}
            </MenuItem>
          ))}
        </Menu>
      </>
    );
  }
}

const StyledRowHeightDiv = styled.div`
  margin: 3px;
  border-radius: 4px;
  padding: 5px;
  cursor: pointer;
  align-items: center;
  &:hover {
    background-color: ${COLORS.ACTIONS_HOVER};
  }
`;

const StyledHeightTitle = styled.div`
  color: ${COLORS.TEXT_COLOR};
  font-size: 12px;
  font-weight: 500;
  padding: 2px;
  padding-left: 5px;
`;

export default observer(RowHeight);
